import {Component, Inject} from '@angular/core';
import {kanUsersService} from "../../../services/services/users";
import {User} from "../../../../classes/user";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Dog} from "../../../../classes/dog";
import {kanDogsService} from "../../../services/services/dogs";
import {kanMembershipService} from "../../../services/services/membership";
import {MembershipType} from "../../../../classes/membershipType";
import {getDateString} from "../../../../utils/dateFormat";

@Component({
    selector: 'kan-membership-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanMembershipDialog {
    public user: User;
    public dog: Dog;
    public membershipType: string;
    public membershipTypes: MembershipType[] = [];
    public oldMembershipType: string;
    public membershipNumber: string;
    public oldMembershipNumber: string;
    public date: string = getDateString(new Date());
    public renewalDate: string = getDateString(new Date());
    public membershipTypeLogs: any[] = [];

    public membershipForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanMembershipDialog>,
                private formBuilder: FormBuilder,
                private usersService: kanUsersService,
                private dogsService: kanDogsService,
                private membershipService: kanMembershipService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.user) {
            this.user = this.data.user;
            this.oldMembershipNumber = this.membershipNumber = this.user.membershipNumber;
        }

        if (this.data && this.data.dog) {
            this.dog = this.data.dog;

            this.membershipTypeLogs = (this.dog.membershipTypeLogs || []).sort((item1, item2) => {

                let d1 = new Date(item1.created);
                let d2 = new Date(item2.created);

                return d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
            });

            this.oldMembershipType = this.membershipType = this.dog.membershipType ? this.dog.membershipType.id : null;
            this.date = this.dog.membershipDate ? getDateString(this.dog.membershipDate) : getDateString(new Date());
            this.renewalDate = this.dog.membershipRenewalDate ? getDateString(this.dog.membershipRenewalDate) : getDateString(new Date());
        }
    }

    ngOnInit(): void {
        this.membershipService.getTypes()
            .then((membershipTypes: MembershipType[]) => {
                this.membershipTypes = [{
                    id: 'unregister',
                    type: 'dar de baja',
                    description: ''
                }].concat(membershipTypes);
                // this.membershipTypes = membershipTypes;
            })
            .catch((error: any) => {
                console.log(error);
            });

        this.membershipForm = this.formBuilder.group({
            membershipNumber: new FormControl(this.membershipNumber, [Validators.required]),
            membershipType: new FormControl(this.membershipType, [Validators.required]),
            date: new FormControl(this.date, [Validators.required]),
            renewalDate: new FormControl(this.renewalDate)
        });
    }

    public updateMembership(event: any) {
        let promises = [];
        if (this.membershipNumber !== this.oldMembershipNumber) {
            this.user.membershipNumber = this.membershipNumber;
            promises.push(this.usersService.updateUser(this.user));
        }

        //if (this.membershipType !== this.oldMembershipType) {
            promises.push(this.dogsService.updateMembershipType(this.dog, this.membershipType, new Date(this.date), new Date(this.renewalDate)));
        //}

        Promise.all(promises)
            .then((data) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/membership-dialog/component.ts